//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast } from 'vant'
import demandAddForm from '../modules/demandAddForm'
import supplyDemandAddForm from '../modules/supplyDemandAddForm'
import quoLoginModule from "@/pages/product/quoLoginModule"

export default {
  name: "home",
  data() {
    return {
      userInfo: this.$store.getters.getUserInfo,
      value: "",
      active: 1,
      activeD: 1,
      checkSysProdType: "-1",//当前选中的方案分类id
      checkCompanyType : "-1",//当前选中的企业分类id
      pageSizeSel: 6, //首页各项默认显示几条
      companyTypeList: null ,//企业分类 list
      companyInfoList: null ,//企业list
      releaseProdCaseList: null ,//产品方案list
      prodTypeList: null, // 产品方案分类list
      userDemandList: null, //客户需求list
      gridList:[],//网格信息list
      showMoreCase: true,//是否显示查看更多案例按钮 true显示
      showMoreCompany: true,//是否显示查看更多企业按钮 true显示
      showMoreDemand: true,//是否显示查看更多需求按钮 true显示
      showMoreGird: true,//是否显示查看更多网格信息按钮 true显示
      supplyDemandList: null, // 服务行list
      showMoreSupplyDemand: true, //是否显示查看更多需求按钮 true显示

    };
  },
  activated () {
    this.userInfo = this.$store.getters.getUserInfo
  },
  components: { Header, Footer, demandAddForm,supplyDemandAddForm,quoLoginModule },
  computed: {
    text() {
      return {};
    },
  },
  methods: {
    hideTel(e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
       document.querySelectorAll("div.box").forEach((item)=>{
        item.style.display = "none"
      })

    },
    showTel(e){
      this.fnStopBub(e);
      document.querySelectorAll("div.box").forEach((item)=>{
        item.style.display = "none"
      })
      e.currentTarget.nextElementSibling.style.display = "block"
    },
    fnShowDemand(){
      console.log(this.userInfo)
      if (this.userInfo && this.userInfo.id) {
        this.$refs.supplyDemandAddForm.showForm(this.userInfo)
      } else {
        this.$refs.quoLoginModule.showLogin()
      }
    },
    handleLognSucccessDemand (userInfo) {
      this.$refs.Header.fnSetUserInfo(userInfo)
      this.userInfo = userInfo
      this.fnShowDemand()
    },
    //切换产品分类
    showProdTypeTab(params,e){
      this.fnStopBub(e);
      this.checkSysProdType = params;
      this.fnLoadReleaseProdCase(2);
    },
    /* 加载更多方案数据*/
    fnLoadReleaseProdCase(inType){
      let that = this;
      let xmpcCpalSelObj = new Object();
      let page = new Object();
      page.pageNum = 0;
      page.pageSize = that.pageSizeSel;
      xmpcCpalSelObj.page = page;
      xmpcCpalSelObj.selSysProdTypeId = that.checkSysProdType;
      xmpcCpalSelObj.quotedPriceType = 1;
      requestByPost(API.selReleaseProdCasePageForHome,JSON.stringify(xmpcCpalSelObj)).then((res)=>{
        if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.releaseProdCaseList != null &&  res.data.obj.releaseProdCaseList.length != 0){
          that.releaseProdCaseList = res.data.obj.releaseProdCaseList;
          if(that.releaseProdCaseList.length == res.data.obj.page.total){
            that.showMoreCase = false;
          }else{
            that.showMoreCase = true;
          }
          // if(inType == 1){
          //   that.prodTypeList = res.data.obj.prodTypeList;
          // }
        }else{
          that.showMoreCase = false;
          that.releaseProdCaseList = null;
          // if(inType == 1){
          //   that.prodTypeList = null;
          // }
        }
      })
    },

    //切换企业分类
    showCompanyTypeTab(params,e){
      this.fnStopBub(e);
      this.checkCompanyType = params;
      this.fnLoadCompanyInfoList(2);

    },
    //根据条件查询
    fnLoadCompanyInfoList(inType){
      let that = this;
      var selObj = new Object();
      let page = new Object();
      page.pageNum = 0;
      page.pageSize = that.pageSizeSel;
      selObj.page = page;
      selObj.companyType = that.checkCompanyType;
      requestByPost(API.selCompanyInfoPageFormEs,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.companyInfoList != null &&  res.data.obj.companyInfoList.length != 0){
          that.companyInfoList = res.data.obj.companyInfoList;
          if(that.companyInfoList.length == res.data.obj.page.total){
            that.showMoreCompany = false;
          }else{
            that.showMoreCompany = true;
          }
          // if(inType == 1){
          //   that.companyTypeList = res.data.obj.companyTypeList;
          // }
        }else{
          that.showMoreCompany = false;
          that.companyInfoList = null;
          // if(inType == 1){
          //   that.companyTypeList = null;
          // }
        }
      })
    },

    /* 加载客户需求list */
    fnLoadUserDemandList(){
      let that = this;
      let selObj = new Object();
      let page = new Object();
      page.pageNum = 0;
      page.pageSize = 4;
      selObj.page = page;
      selObj.sortType = 1;
      requestByPost(API.selUserDemandPageForHome,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.userDemandList != null &&  res.data.obj.userDemandList.length != 0){
          that.userDemandList = res.data.obj.userDemandList;
          if(that.userDemandList.length == res.data.obj.page.total){
            that.showMoreDemand = false;
          }else{
            that.showMoreDemand = true;
          }
        }else{
          that.userDemandList = null;
          that.showMoreDemand = false;
        }
      })
    },
    fnSupplyDemandList () {
      let that = this;
      let selObj = new Object();
      let page = new Object();
      page.pageNum = 0;
      page.pageSize = 4;
      selObj.page = page;
      selObj.sortType = 1;
      requestByPost(API.selSupplyDemandShowPage,JSON.stringify(selObj)).then((res) => {
        if (res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.supplyDemandList != null && res.data.obj.supplyDemandList.length != 0) {
          that.supplyDemandList = res.data.obj.supplyDemandList;
          console.log(that.supplyDemandList)
          if (that.supplyDemandList.length == res.data.obj.page.total) {
            that.showMoreSupplyDemand = false;
          }else{
             that.showMoreSupplyDemand = true;
          }
        }else{
          that.supplyDemandList = null;
          that.showMoreSupplyDemand = false;
        }
      })
    },
    /* 加载网格信息list */
    fnLoadGirdList(){
      let that = this;
      let selObj = new Object();
      let page = new Object();
      page.pageNum = 0;
      page.pageSize = that.pageSizeSel;
      selObj.page = page;
      selObj.isSelGird = 1;
      requestByPost(API.selGridPageForHome,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.otherList != null &&  res.data.otherList.length != 0){
          that.gridList = res.data.otherList;
          if(that.gridList.length == res.data.obj.page.total){
            that.showMoreGird = false;
          }else{
            that.showMoreGird = true;
          }
        }else{
          that.gridList = null;
          that.showMoreGird = false;
        }
      })
    },

    //跳转到案例详情页
    fnGotoCaseDetail(id,e){
      this.fnStopBub(e);
      this.$router.push({path: '/caseDetail', query: {projectId:id,inType:0}});
    },
    //跳转到企业发布信息详情页
    fnGotoCompanyDetail(id,e){
      this.fnStopBub(e);
       this.$router.push({path: '/companyDetailNew', query: {companyId:id,inType:0}});
    },
    // 跳转页面-用户中心  发布需求
    fnGoToPageUcDemand(e){
      this.fnStopBub(e);
      // this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
      this.$refs.demandAddForm.showForm()
    },
    fnGoToMyDemand () {
      this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:''})
    },
   //跳转到找合作  搜索页直接查 2企业  、  1 产品
    fnGotoSearchPage(selType,e){
      this.fnStopBub(e);
      this.$router.push({path: '/search', query: {selType:selType}});
    },
    fnShowSocietyIndex(societyId,societyName,logoImgUrl,e){
      this.fnStopBub(e);
      // this.$store.commit('home/setSocietyLogoUrl', logoImgUrl);//机构logo
      // this.$store.commit('home/setCommonSocietyId', societyId);//机构菜单
      // this.$store.commit('home/setCommonSocietyName', societyName);//机构菜单
      window.localStorage.setItem('societyId',societyId);
      window.localStorage.setItem('societyName',societyName);
      window.localStorage.setItem('logoImgUrl',logoImgUrl);
      this.$router.push({path: '/societyIndex', query: {societyId:societyId,societyName:societyName,logoImgUrl:logoImgUrl}});
    },
    fnGotoGxxxPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/demand'});
    },
    fnGotoWgxcPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/grid'});
    },
    handleSaveDemandSuccess () {
      this.fnLoadUserDemandList()
    },
    handleDemandSuccess () {
      this.fnSupplyDemandList()
    },
    handleLognSucccess (userInfo) {
      this.userInfo = userInfo
      this.$refs.Header.fnSetUserInfo(userInfo)
    },
    handleUserDemandClicked (e, userDemand) {
      this.fnStopBub(e);
      this.$router.push({path: '/demandDetail', query: {demandId: userDemand.id,inType:0}});
    },
    handleSupplyDemandClicked (e, supplyDemand) {
      this.fnStopBub(e);
      if (supplyDemand.linkType == 0) {
        if(supplyDemand.companyId != null && supplyDemand.companyId != '' && supplyDemand.companyId != '-1'){
          this.$router.push({path: '/companyDetailNew', query: {companyId: supplyDemand.companyId,inType:0}});
        }else{
          Toast("企业未维护主页，无法查看");
        }
        
      } else if (supplyDemand.linkType == 1) {
        this.$router.push({path: '/caseDetail', query: {projectId: supplyDemand.projectId,inType:0}});
      } else if (supplyDemand.linkType == 2) {
        window.open(supplyDemand.linkStr)
      } else {
        return
      }
      
    },
    //初始化企业分类list
    fnLoadCompanyTypeList(){
      let that = this;
      var selObj = new Object();
      requestByPost(API.selCompanyTypeFormDb,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.objs != undefined && res.data.objs != null && res.data.objs.length != 0){
          that.companyTypeList = res.data.objs;
        }else{
          that.companyTypeList = null;
        }
      })
    },
    //初始化产品分类list
    fnLoadProdTypeList(){
      let that = this;
      var selObj = new Object();
      requestByPost(API.selProdTypeFormDb,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.objs != undefined && res.data.objs != null && res.data.objs.length != 0){
          that.prodTypeList = res.data.objs;
        }else{
          that.prodTypeList = null;
        }
      })
    },
    //分辨率控制公司名称字体大小
    fnGetFontSizeNum(companyName){
       // 分辨率控制字体大小
      if(window.screen.width <= 1367 && companyName.length > 13){
        return  "font-size: 18px;";
      }
      return "font-size: 21px;";
    },
    //分辨率控制机构名称字体大小
    fnGetJgFontSizeNum(companyName){
       // 分辨率控制字体大小
      if(window.screen.width <= 1367 && companyName.length > 17){
        return  "font-size: 18px;margin-bottom: 11px;";
      }
      return "font-size: 21px;";
    },

    //分辨率控制公司关键字显示数量
    fnGetShowLeyWordArr(keywordValueArr){
      let showArr = [];
      if(window.screen.width <= 1367){
        if(keywordValueArr != null && keywordValueArr.length > 0){
          if(keywordValueArr.length > 2){
            let num = 0;
            $(keywordValueArr).each(function(index,keyword){
              num += keyword.length;
              if(index == 0){
                showArr[showArr.length] = keyword;
              }else if(index == 1){
                showArr[showArr.length] = keyword;
              }else if(index == 2){
                if(num < 20){
                  showArr[showArr.length] = keyword;
                }
              }
            });
          }else if(keywordValueArr.length <= 2){
            showArr = keywordValueArr;
          }
        }
        return  showArr;
      }else if(window.screen.width <= 1600){
        if(keywordValueArr != null && keywordValueArr.length > 0){
          if(keywordValueArr.length > 2){
            let num = 0;
            $(keywordValueArr).each(function(index,keyword){
              num += keyword.length;
              if(index == 0){
                showArr[showArr.length] = keyword;
              }else if(index == 1){
                showArr[showArr.length] = keyword;
              }else if(index == 2){
                if(num < 22){
                    showArr[showArr.length] = keyword;
                }
              }
            });
          }else if(keywordValueArr.length <= 2){
            showArr = keywordValueArr;
          }
          return  showArr;
        }
      }else{
        return keywordValueArr;
      }
    },


  },
  mounted() {
    document.title = "觅圈圈";
  },
  created() {
    this.$store.commit('home/setMenuActive', 0);
    this.$store.commit('home/setShowMenuType', 0);//平台菜单
    this.$store.commit('home/setCommonSocietyId', null);//机构菜单
    this.$store.commit('home/setCommonSocietyName', null);//机构菜单
    this.$store.commit('home/setSocietyLogoUrl', null);//机构菜单
    
    window.localStorage.removeItem('societyId');
    window.localStorage.removeItem('societyName');
    window.localStorage.removeItem('logoImgUrl');
    //初始化企业分类list
    this.fnLoadCompanyTypeList();
    //初始化产品分类list
    this.fnLoadProdTypeList();
    //初始化企业list
    this.fnLoadCompanyInfoList(1);
    //初始化方案list
    this.fnLoadReleaseProdCase(1);
    //初始化客户需求列表
    this.fnLoadUserDemandList();
    //初始化服务商信息
    this.fnSupplyDemandList();
    //初始化网格信息
    this.fnLoadGirdList();
  },

  updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    $$(".autoCompanyImgHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*7.52/16);
    });
    
  }

};



// WEBPACK FOOTER //
// ./src/pages/home/home-old.vue